export const SENSITIVE_DATA_CLASS = 'fs-hide amp-mask';
export default SENSITIVE_DATA_CLASS;
